import * as React from "react";
const GoogleBusinessColorIcon = () => (
  <svg
    width={30}
    height={27}
    viewBox="0 0 30 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7175 6.64062H2.54764C1.97336 6.64062 1.50781 7.11241 1.50781 7.69439V25.4776C1.50781 26.0596 1.97336 26.5314 2.54764 26.5314H26.7175C27.2918 26.5314 27.7573 26.0596 27.7573 25.4776V7.69439C27.7573 7.11241 27.2918 6.64062 26.7175 6.64062Z"
      fill="#4989F5"
    />
    <path
      d="M26.4112 6.49219H2.81904C2.08822 6.49219 1.51953 12.2239 1.51953 12.9645L14.4393 26.5324H26.4112C27.1443 26.5303 27.738 25.9286 27.74 25.1857V7.83854C27.7379 7.09576 27.1442 6.49422 26.4112 6.49219Z"
      fill="url(#paint0_linear_20061_10423)"
    />
    <path d="M7.5 9.97537H14.9999V0H8.62301L7.5 9.97537Z" fill="#3C4BA6" />
    <path
      d="M22.4999 9.97537H15V0H21.3769L22.4999 9.97537ZM27.756 1.89095L27.7653 1.92496C27.763 1.91296 27.7585 1.90181 27.756 1.89095Z"
      fill="#7BABF7"
    />
    <path
      d="M27.7673 1.92496L27.758 1.89095C27.5203 0.787555 26.5565 0.000714322 25.4421 0H21.3789L22.5011 9.97565H30.0009L27.7673 1.92496Z"
      fill="#3F51B5"
    />
    <path
      d="M2.24759 1.89062L2.23828 1.92434C2.24054 1.91244 2.24505 1.90139 2.24759 1.89062Z"
      fill="#7BABF7"
    />
    <path
      d="M2.23502 1.92496L2.24432 1.89095C2.48209 0.787555 3.44579 0.000714322 4.56026 0H8.62372L7.49987 9.97565H0L2.23502 1.92496Z"
      fill="#7BABF7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.51126 9.96875C7.51126 12.0663 5.83329 13.7668 3.76344 13.7668C1.69359 13.7668 0.015625 12.0663 0.015625 9.96875H7.51126Z"
      fill="#709BE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0074 9.96875C15.0074 12.0663 13.3294 13.7668 11.2595 13.7668C9.18969 13.7668 7.51172 12.0663 7.51172 9.96875H15.0074Z"
      fill="#3C4BA6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5074 9.96875C22.5074 12.0663 20.8294 13.7668 18.7595 13.7668C16.6897 13.7668 15.0117 12.0663 15.0117 9.96875H22.5074Z"
      fill="#709BE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9995 9.96875C29.9995 12.0663 28.3216 13.7668 26.2517 13.7668C24.1819 13.7668 22.5039 12.0663 22.5039 9.96875H29.9995Z"
      fill="#3C4BA6"
    />
    <path
      d="M26.2524 20.2617C26.2391 20.0808 26.2171 19.9156 26.1858 19.7048H22.0975C22.0975 20.2842 22.0975 20.9165 22.0953 21.4963H24.4637C24.4134 21.7665 24.3109 22.0239 24.1621 22.2538C24.0133 22.4838 23.8211 22.6816 23.5967 22.8361C23.5967 22.8361 23.5967 22.8261 23.595 22.8258C23.3051 23.0187 22.9785 23.1478 22.6363 23.2049C22.2933 23.2685 21.9416 23.267 21.5991 23.2004C21.2513 23.1274 20.922 22.9828 20.6317 22.7755C20.2032 22.4675 19.8726 22.0396 19.6807 21.544C19.666 21.5054 19.6525 21.4666 19.6387 21.4271V21.4229L19.6423 21.42C19.456 20.8658 19.4555 20.2647 19.6409 19.7102C19.7715 19.3212 19.9865 18.9668 20.2699 18.673C20.935 17.9758 21.9286 17.7136 22.8447 17.9935C23.196 18.1027 23.5169 18.2942 23.7816 18.5524L24.5807 17.7427C24.7216 17.5984 24.868 17.4587 25.0036 17.3095C24.5984 16.9265 24.1229 16.6281 23.604 16.4312C22.6597 16.0842 21.6267 16.075 20.6765 16.4052C20.6434 16.4166 20.6105 16.4285 20.5778 16.4409C19.5528 16.8314 18.7095 17.5973 18.2145 18.5873C18.0398 18.9377 17.9125 19.3104 17.8362 19.6953C17.3836 21.9747 18.756 24.2183 20.9717 24.8213C21.696 25.0179 22.466 25.013 23.196 24.845C23.8592 24.6933 24.4725 24.3703 24.9762 23.9076C25.5018 23.4175 25.8785 22.7646 26.0759 22.0712C26.2409 21.4835 26.3006 20.8707 26.2524 20.2617Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_20061_10423"
        x1={1.51953}
        y1={9311.86}
        x2={27899.8}
        y2={9311.86}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.03} stopColor="#4079D8" />
        <stop offset={1} stopColor="#4989F5" />
      </linearGradient>
    </defs>
  </svg>
);
export default GoogleBusinessColorIcon;
